// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"89":"testimonials-section","130":"featured-products"}[chunkId] || chunkId) + "." + {"89":"e2043d8d","130":"0f92cd2c","535":"593b8c40","746":"f3983f2c"}[chunkId] + ".chunk.css";
};